import { all, takeEvery, fork } from 'redux-saga/effects';
import React from 'react';
import { notification } from 'antd';

import Translation from '../../components/UI/Translation';
import { SHOW_NOTIFICATION, NotificationData } from './types';
import { AnyAction } from 'redux';

export function* showNotificationWatcher(): Generator {
  yield takeEvery(SHOW_NOTIFICATION, showNotification);
}
/**
 * wyświetlenie powiadomienia
 *
 * @export
 * @param {AnyAction} action
 * @return {*}  {Generator}
 */
export function* showNotification(action: AnyAction): Generator {
  const { notifType, titleTranslationKey = '', bodyTranslationKey = '', code = '' }: NotificationData = action.payload;
  const args = {
    top: 100,
    message: <Translation id={titleTranslationKey} />,
    description: (
      <>
        <Translation id={bodyTranslationKey} />
        {code}
      </>
    ),
    duration: action.payload.duration ? action.payload.duration : 5,
  };
  yield notification[notifType](args);
}

export default function* rootSaga(): Generator {
  yield all([fork(showNotificationWatcher)]);
}
